// "Acesso rápido" da tela Início (desktop) — pedido 2026-09-03: admin
// escolhe até 6 atalhos, persistido no PRÓPRIO usuário (backend, nunca
// localStorage — sobrevive a troca de navegador/dispositivo). Exclusivo do
// web: o "Acesso rápido" do app do cliente (PWA) é fixo e nunca lê isso,
// ver InicioPanel em components/mobile-app.tsx.
import { gpsDriveGet, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface QuickAccessTileDef {
  key: string;
  label: string;
  description: string;
}

export interface QuickAccessCatalogResponse {
  catalog: QuickAccessTileDef[];
  maxTiles: number;
}

export const gpsDriveQuickAccessService = {
  getCatalog: () => gpsDriveGet<QuickAccessCatalogResponse>("/api/v1/users/quick-access/catalog"),
  getMine: () => gpsDriveGet<{ tiles: string[] }>("/api/v1/users/me/quick-access"),
  updateMine: (tiles: string[]) =>
    gpsDrivePut<{ tiles: string[] }>("/api/v1/users/me/quick-access", { tiles }),
};
